import React from 'react';

const EyeCatchingHeading = ({ title, styleType = 1, className = '' }) => {
  const headingStyles = {
    1: {
      // Rainbow Gradient with Glow
      background: 'linear-gradient(45deg, #ff0080, #ff8c00, #40e0d0, #00ff00, #0080ff, #8000ff, #ff0080)',
      backgroundSize: '300% 300%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'rainbowFlow 3s ease-in-out infinite',
      textShadow: '0 0 20px rgba(255, 0, 128, 0.5), 0 0 40px rgba(255, 140, 0, 0.3), 0 0 60px rgba(64, 224, 208, 0.2)',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      textAlign: 'center'
    },
    2: {
      // Neon Cyberpunk
      color: '#00ffff',
      textShadow: '0 0 5px #00ffff, 0 0 10px #00ffff, 0 0 15px #00ffff, 0 0 20px #00ffff',
      fontWeight: '900',
      fontSize: '1.125rem',
      textAlign: 'center',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      animation: 'cyberpunkGlow 2s ease-in-out infinite alternate'
    },
    3: {
      // Holographic Chrome
      background: 'linear-gradient(45deg, #ff0066, #00ff66, #6600ff, #ff6600, #00ffcc, #ff0066)',
      backgroundSize: '400% 400%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'holographicShift 4s ease-in-out infinite',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      textAlign: 'center',
      filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))'
    },
    4: {
      // Electric Purple
      color: '#8b5cf6',
      textShadow: '0 0 10px #8b5cf6, 0 0 20px #8b5cf6, 0 0 30px #8b5cf6, 0 0 40px #8b5cf6',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      textAlign: 'center',
      animation: 'electricPulse 2.5s ease-in-out infinite'
    },
    5: {
      // Gold Luxury
      background: 'linear-gradient(45deg, #ffd700, #ffed4e, #ffd700, #ffed4e)',
      backgroundSize: '200% 200%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'goldShimmer 3s ease-in-out infinite',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      textAlign: 'center',
      filter: 'drop-shadow(0 0 8px rgba(255, 215, 0, 0.6))'
    },
    6: {
      // Hot Pink Neon
      color: '#ff1493',
      textShadow: '0 0 8px #ff1493, 0 0 16px #ff1493, 0 0 24px #ff1493',
      fontWeight: '900',
      fontSize: '1.125rem',
      textAlign: 'center',
      animation: 'hotPinkFlicker 1.8s ease-in-out infinite',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    7: {
      // Cosmic Blue
      background: 'linear-gradient(45deg, #1e40af, #3b82f6, #60a5fa, #93c5fd, #3b82f6, #1e40af)',
      backgroundSize: '300% 300%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'cosmicWave 3.5s ease-in-out infinite',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      textAlign: 'center',
      filter: 'drop-shadow(0 0 12px rgba(59, 130, 246, 0.5))'
    },
    8: {
      // Aurora Green
      background: 'linear-gradient(120deg, #bbf7d0, #34d399, #047857)',
      backgroundSize: '250% 250%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'auroraDrift 4s ease-in-out infinite',
      fontWeight: '800',
      fontSize: '1.15rem',
      textAlign: 'center',
      letterSpacing: '0.75px',
      filter: 'drop-shadow(0 0 12px rgba(16, 185, 129, 0.45))'
    },
    9: {
      // Solar Flare
      color: '#f97316',
      textShadow: '0 0 6px rgba(249, 115, 22, 0.8), 0 0 14px rgba(249, 115, 22, 0.4), 0 0 26px rgba(249, 115, 22, 0.25)',
      fontWeight: '900',
      fontSize: '1.2rem',
      textAlign: 'center',
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
      animation: 'solarPulse 2.5s ease-in-out infinite',
      fontStyle: 'italic'
    },
    10: {
      // Midnight Silver
      color: '#f1f5f9',
      textShadow: '0 0 8px rgba(148, 163, 184, 0.6), 0 0 18px rgba(226, 232, 240, 0.3)',
      fontWeight: '700',
      fontSize: '1.15rem',
      textAlign: 'center',
      letterSpacing: '0.35px',
      fontFamily: '"Trebuchet MS", "Segoe UI", sans-serif',
      animation: 'midnightGlow 3.6s ease-in-out infinite'
    },
    11: {
      // Luminous Coral
      background: 'linear-gradient(135deg, #fb7185, #f97316, #facc15)',
      backgroundSize: '220% 220%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'coralShimmer 3.2s ease-in-out infinite',
      fontWeight: '800',
      fontSize: '1.18rem',
      textAlign: 'center',
      letterSpacing: '1px',
      filter: 'drop-shadow(0 0 10px rgba(251, 113, 133, 0.45))'
    },
    12: {
      // Electric Indigo
      color: '#a855f7',
      textShadow: '0 0 10px rgba(168, 85, 247, 0.9), 0 0 24px rgba(129, 140, 248, 0.5)',
      fontWeight: '900',
      fontSize: '1.22rem',
      textAlign: 'center',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      fontFamily: '"Orbitron", "Arial Black", sans-serif',
      animation: 'indigoPulse 2.2s ease-in-out infinite alternate'
    },
    13: {
      // Opal Mist
      background: 'linear-gradient(100deg, rgba(214, 211, 254, 0.95), rgba(165, 243, 252, 0.85), rgba(253, 230, 138, 0.9))',
      backgroundSize: '300% 300%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'opalGlow 5s ease-in-out infinite',
      fontWeight: '700',
      fontSize: '1.16rem',
      textAlign: 'center',
      letterSpacing: '0.6px',
      filter: 'drop-shadow(0 0 16px rgba(224, 231, 255, 0.55))'
    },
    14: {
      // Meteor Crimson
      color: '#ef4444',
      textShadow: '0 0 12px rgba(239, 68, 68, 0.8), 0 0 28px rgba(239, 68, 68, 0.5)',
      fontWeight: '900',
      fontSize: '1.24rem',
      textAlign: 'center',
      letterSpacing: '1.2px',
      textTransform: 'uppercase',
      animation: 'meteorStreak 1.9s ease-in-out infinite',
      fontFamily: '"Bebas Neue", "Impact", sans-serif'
    }
  };

  const totalStyleVariants = Object.keys(headingStyles).length;

  const hashSeed = (seed) => {
    if (!seed) {
      return 0;
    }

    let hash = 0;
    for (let i = 0; i < seed.length; i += 1) {
      hash = (hash << 5) - hash + seed.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  };

  const normalizeStyleType = (value, fallbackSeed) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
      const absolute = Math.abs(Math.floor(value));
      if (absolute === 0) {
        return 1;
      }
      return ((absolute - 1) % totalStyleVariants) + 1;
    }

    if (typeof value === 'string' && value.trim() !== '') {
      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        return normalizeStyleType(numericValue, fallbackSeed);
      }
      const hashed = hashSeed(value);
      if (hashed > 0) {
        return (hashed % totalStyleVariants) + 1;
      }
    }

    if (fallbackSeed && typeof fallbackSeed === 'string' && fallbackSeed.trim() !== '') {
      const hashed = hashSeed(fallbackSeed);
      if (hashed > 0) {
        return (hashed % totalStyleVariants) + 1;
      }
    }

    return 1;
  };

  const resolvedStyleType = normalizeStyleType(styleType, title);
  const selectedStyle = headingStyles[resolvedStyleType] || headingStyles[1];

  return (
    <>
      <h3 
        className={`line-clamp-1 ${className}`}
        style={selectedStyle}
      >
        {title}
      </h3>
      
      {/* CSS Animations */}
      <style jsx>{`
        @keyframes rainbowFlow {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes cyberpunkGlow {
          0% { 
            text-shadow: 0 0 5px #00ffff, 0 0 10px #00ffff, 0 0 15px #00ffff, 0 0 20px #00ffff;
          }
          100% { 
            text-shadow: 0 0 10px #00ffff, 0 0 20px #00ffff, 0 0 30px #00ffff, 0 0 40px #00ffff;
          }
        }
        
        @keyframes holographicShift {
          0%, 100% { background-position: 0% 50%; }
          25% { background-position: 100% 50%; }
          50% { background-position: 50% 100%; }
          75% { background-position: 50% 0%; }
        }
        
        @keyframes electricPulse {
          0%, 100% { 
            text-shadow: 0 0 10px #8b5cf6, 0 0 20px #8b5cf6, 0 0 30px #8b5cf6, 0 0 40px #8b5cf6;
          }
          50% { 
            text-shadow: 0 0 20px #8b5cf6, 0 0 40px #8b5cf6, 0 0 60px #8b5cf6, 0 0 80px #8b5cf6;
          }
        }
        
        @keyframes goldShimmer {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes hotPinkFlicker {
          0%, 100% { 
            text-shadow: 0 0 8px #ff1493, 0 0 16px #ff1493, 0 0 24px #ff1493;
          }
          50% { 
            text-shadow: 0 0 12px #ff1493, 0 0 24px #ff1493, 0 0 36px #ff1493;
          }
        }
        
        @keyframes cosmicWave {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes auroraDrift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        @keyframes solarPulse {
          0%, 100% { transform: scale(1); opacity: 0.95; }
          45% { transform: scale(1.06); opacity: 1; }
          60% { transform: scale(0.98); opacity: 0.85; }
        }

        @keyframes midnightGlow {
          0%, 100% { text-shadow: 0 0 8px rgba(148, 163, 184, 0.65), 0 0 18px rgba(226, 232, 240, 0.35); }
          50% { text-shadow: 0 0 16px rgba(148, 163, 184, 0.8), 0 0 32px rgba(226, 232, 240, 0.45); }
        }

        @keyframes coralShimmer {
          0%, 100% { background-position: 0% 100%; }
          50% { background-position: 100% 0%; }
        }

        @keyframes indigoPulse {
          0% { text-shadow: 0 0 12px rgba(168, 85, 247, 0.75), 0 0 26px rgba(129, 140, 248, 0.45); transform: scale(1); }
          100% { text-shadow: 0 0 20px rgba(168, 85, 247, 1), 0 0 36px rgba(129, 140, 248, 0.65); transform: scale(1.04); }
        }

        @keyframes opalGlow {
          0%, 100% { background-position: 0% 0%; }
          33% { background-position: 50% 100%; }
          66% { background-position: 100% 50%; }
        }

        @keyframes meteorStreak {
          0%, 100% { text-shadow: 0 0 12px rgba(239, 68, 68, 0.75), 0 0 28px rgba(239, 68, 68, 0.5); transform: skewX(0deg); }
          50% { text-shadow: 0 0 22px rgba(239, 68, 68, 0.95), 0 0 40px rgba(239, 68, 68, 0.6); transform: skewX(-3deg); }
        }
      `}</style>
    </>
  );
};

export default EyeCatchingHeading;
